import { colors } from './colors';
import { motion } from './interaction-states';
import { radius } from './radius';
import { shadows } from './shadows';
import { spacing } from './spacing';
import { typography } from './typography';

export const theme = {
  colors,
  spacing,
  radius,
  shadows,
  motion,
  typography,
};

declare module '@emotion/react' {
  export interface Theme {
    colors: typeof colors;
    spacing: typeof spacing;
    radius: typeof radius;
    shadows: typeof shadows;
    motion: typeof motion;
    typography: typeof typography;
  }
}
